import React, { useMemo } from 'react';
import { ReusableModal } from '../modals/ReusableModal';
import {
  MaintenanceNoticeRecord,
  NoticeRecord,
  NoticeRecordListItem,
} from '@/types/api/NoticeRecord';
import { toDateString } from '../utils/dateUtils';
import { getRawNoticeUrl } from './noticeSlice';

export type RawNoticeModalProps = {
  notice: NoticeRecord | MaintenanceNoticeRecord | NoticeRecordListItem | null;
  isOpen: boolean;
  onClose: () => void;
};

export const RawNoticeModal: React.FC<RawNoticeModalProps> = ({
  notice,
  isOpen,
  onClose,
}) => {
  const rawNoticePath = useMemo(
    () => (notice ? getRawNoticeUrl(notice) : ''),
    [notice],
  );
  return (
    <ReusableModal
      size="xl"
      isOpen={isOpen}
      toggle={onClose}
      header={
        notice
          ? `Notice for ${notice.identifier} on ${toDateString(
              notice.start_gas_date ?? new Date(),
            )}`
          : ''
      }
    >
      {rawNoticePath.endsWith('.pdf') || rawNoticePath.endsWith('.html') ? (
        <iframe
          title="pdf"
          src={rawNoticePath}
          width="100%"
          height="900px"
          style={{
            maxHeight: '80vh',
            backgroundColor: 'white',
          }}
          allow="autoplay"
        />
      ) : (
        'No raw data found.'
      )}
    </ReusableModal>
  );
};
